import type { BadgeColor } from '@/lib/components/designSystem/badges/badges'
import type { StoreRole, SystemRole } from '@state/user'

export function getRoleBadgeColor(role: SystemRole | StoreRole): BadgeColor<'color'> {
  switch (role) {
    case 'ADMIN':
      return 'error'
    case 'CONTRIBUTOR':
      return 'warning'
    case 'STORE_MANAGER':
      return 'warning'
    case 'STORE_EMPLOYEE':
      return 'brand'
    case 'STORE_VIEWER':
      return 'gray'
    default:
      return 'gray'
  }
}